import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthedHomeRedirectGuard } from '@common/auth/services/authed-home-redirect.guard';
import { kioskLockAppGuard } from '@app/features/erp-apps/restaurant/core/kiosk-lock.rule';
import { WalkthroughPage } from './walkthrough/walkthrough.page';
import * as fromComponents from './components/index';

/**
 * The entry flow (kz2 F1): `''` redirects to `/login` (product.routes.ts). Login and Signup bounce
 * a restored session to its role home. The walkthrough is NOT part of the entry flow: it opens only
 * from Login and Signup, and every exit lands on Signup.
 *
 * kzd r1 polish L1: the walkthrough and Forgot password are only meaningful signed out, so they carry the kiosk
 * lock's app guard. Signed out it reads no business and lets them through (an expired kiosk session still reaches
 * them from /login); signed in on a locked device it sends the visit to the kiosk instead of drawing the staff rail.
 * Login and Signup keep AuthedHomeRedirectGuard alone: signed in, they already go to the role home, which the lock
 * sends on to the kiosk.
 */
const routes: Routes = [
  { path: 'login', component: fromComponents.LoginPage, canActivate: [AuthedHomeRedirectGuard] },
  { path: 'signup', component: fromComponents.SignupPage, canActivate: [AuthedHomeRedirectGuard] },
  // A person rather than a business (consumers; appMode 'all'): the legacy personal signup.
  { path: 'signup/personal', component: fromComponents.SignupFormComponent, canActivate: [AuthedHomeRedirectGuard] },
  { path: 'walkthrough', component: WalkthroughPage, canActivate: [kioskLockAppGuard] },
  { path: 'forgot-password', component: fromComponents.ForgotPasswordPage, canActivate: [kioskLockAppGuard] },
  // Retired routes, kept as redirects so old links and bookmarks still land somewhere sensible.
  { path: 'welcome', redirectTo: 'login', pathMatch: 'full' },
  { path: 'signup-user-role', redirectTo: 'signup', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
